import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EMPRESAS } from "../../app.config";

@Injectable()
export class ParametroEntidadeService {
    headers = new HttpHeaders().set("noloader", "t");
    constructor(private http: HttpClient) {}

    listar(entidade: string, entidadeId: number) {
        return this.http.get<ParametroEntidade[]>(`${EMPRESAS}/api/parametro-entidade/${entidade}/${entidadeId}`, {
            headers: this.headers,
        });
    }

    buscaParametro(entidade: string, entidadeId: number, chave: string) {
        return this.http.get<ParametroEntidade>(
            `${EMPRESAS}/api/parametro-entidade/${entidade}/${entidadeId}/${chave}`,
            { headers: this.headers }
        );
    }

    criarParametro(parametro: ParametroEntidade) {
        return this.http.post(`${EMPRESAS}/api/parametro-entidade/criar`, parametro, { headers: this.headers });
    }

    deletarParametro(entidade: string, entidadeId: number, chave: string) {
        return this.http.delete(`${EMPRESAS}/api/parametro-entidade/${entidade}/${entidadeId}/${chave}`, {
            headers: this.headers,
        });
    }

    atualizarParametro(entidade: string, entidadeId: number, chave: string, novoValor: string, criptografado: boolean) {
        return this.http.put(
            `${EMPRESAS}/api/parametro-entidade/${entidade}/${entidadeId}/${chave}`,
            JSON.stringify({ Valor: novoValor, Criptografado: criptografado }),
            {
                headers: this.headers.set("Content-Type", "application/json"),
            }
        );
    }
}

export type ParametroEntidade = {
    Entidade: string;
    EntidadeId: number;
    Chave: string;
    Valor: string;
    Descricao: string;
    Criptografado: boolean;
};
